<header>
    <div class="div-img-topbar">
        <img [routerLink]="['dashboard']" src="../../assets/icons/icon-128x128.png" alt="Plenion logo" />
    </div>

    <div id="elem-navtop">
        <div id="language-dropdown" [matMenuTriggerFor]="menuLanguage">
            <span>{{ selected }}</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
        </div>
        <mat-menu #menuLanguage="matMenu" (change)="selectLanguageHandler($event)">
            <a (click)="onChangeLanguage('en')" value="EN" mat-menu-item>
                <span>English</span>
            </a>
            <a (click)="onChangeLanguage('fr')" value="FR" mat-menu-item>
                <span>Français</span>
            </a>
            <a (click)="onChangeLanguage('nl')" value="NL" mat-menu-item>
                <span>Nederlands</span>
            </a>
        </mat-menu>



		<div id="user-dropdown" [matMenuTriggerFor]="menuUser">
			<span *ngIf="user && user.username !== undefined && user.username !== 'null'">{{ user.username }}</span>
			<span *ngIf="user && user.username === 'null'">{{ user.email }}</span>
			<mat-icon>keyboard_arrow_down</mat-icon>
			<div id="user-img">
				<img *ngIf="user && !user.isGeneric" [src]="photo" alt="" />
    			<img *ngIf="!user || user.isGeneric || user.photo === 'null'" src="../../assets/img/user-img.png" alt="" />
			</div>
		</div>
		<mat-menu #menuUser="matMenu">
			<a href="https://myaccount.google.com" target="_blank" *ngIf="user && user.type === 'Google' && !user.isGeneric" mat-menu-item>
				<span translate>Profile</span>
				<mat-icon fontSet="material-icons-outlined" class="menu-icon">person</mat-icon>
			</a>
			<a href="https://portal.office.com/account/" target="_blank" *ngIf="user && user.type === 'Office' && !user.isGeneric" mat-menu-item>
				<span translate>Profile</span>
				<mat-icon fontSet="material-icons-outlined" class="menu-icon">person</mat-icon>
			</a>
			<a (click)="onLogout()" mat-menu-item>
				<span translate>Logout</span>
				<mat-icon fontSet="material-icons-outlined" class="menu-icon">logout</mat-icon>
			</a>

			<hr class="menu-separator" />

			<div mat-menu-item class="theme-toggle" (click)="$event.stopPropagation()">
				<mat-icon class="menu-icon">
					{{ darkMode ? 'light_mode' : 'dark_mode' }}
				</mat-icon>
				<mat-slide-toggle [checked]="darkMode" (change)="toggleColorScheme()"></mat-slide-toggle>
			</div>

		</mat-menu>

    </div>
</header>